import { render } from "./UseCasesArea.vue?vue&type=template&id=a7615cfe"
import script from "./UseCasesArea.vue?vue&type=script&lang=js"
export * from "./UseCasesArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__